/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import __ from './i18n.js';
window.__ = __;
window.__localeId__ = 'en';

import * as Sentry from '@sentry/react';
Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
    environment: import.meta.env.APP_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    debug: true,
});

import Clarity from '@microsoft/clarity';
if (! window.__CLARITY_INITIALIZED__) {
    Clarity.init('tu7h04rarn');
    window.__CLARITY_INITIALIZED__ = true;
}
